import { deleteDataAPI, postDataAPI } from './api'

export async function importBandsintownViaAI(artistName: string) {
  if (!artistName || !artistName.trim()) {
    return { success: false, savedCount: 0, error: 'Artist name is required' }
  }

  const prompt = `Find shows for ${artistName} on Bandsintown and add them to my bookings app with status confirmed (so they appear in the confirmed tab), including the correct city and state/province for each show from Bandsintown, and avoiding duplicate bookings if they already exist.`

  const searchResponse = await postDataAPI('user/chatWithAIForDizee', {
    prompt,
    conversation: [],
    conversationId: '',
  })

  const functionResults = searchResponse?.data?.actions_taken
  const conversationId = searchResponse?.data?.conversationId

  if (!Array.isArray(functionResults)) {
    return { success: false, savedCount: 0, error: 'No show data extracted from search' }
  }

  const webSearchResult = functionResults.find((a: any) => a?.type === 'search' && Array.isArray(a?.shows))
  const shows = webSearchResult?.shows || []

  if (!shows.length) {
    return { success: true, savedCount: 0, message: 'No upcoming shows found on Bandsintown' }
  }

  const bookings = shows.map((show: any) => ({
    artist: artistName,
    perf_date: show.date,
    venue: show.venue,
    city: show.city || '',
    state: show.state || '',
    country: show.country || '',
    status: 'confirmed',
    ticket_link: show.ticketLink || '',
    source: 'bandsintown',
    bandsintown_id: show.ticketLink ? String(show.ticketLink).split('/').pop()?.split('?')[0] : '',
  }))

  const importResponse = await postDataAPI('user/bookings/bandsintown/import', { bookings, userId: null })
  const ok = importResponse?.status === 200 && (importResponse?.data?.success || importResponse?.data?.savedCount >= 0)
  const savedCount = importResponse?.data?.savedCount || 0

  // Clean up conversation so it doesn't interfere with other AI prompts (legacy behavior)
  if (conversationId) {
    try {
      await deleteDataAPI(`user/conversations/${conversationId}`)
    } catch {
      // non-critical
    }
  }

  return { success: ok, savedCount, bookings: importResponse?.data?.bookings || [] }
}

